import React from "react";
import ReactDOM from "react-dom";
import { Provider } from "react-redux";
import store from "./store";
import ThemeApp from "./Theme";
import * as serviceWorkerRegistration from "./serviceWorkerRegistration";
import reportWebVitals from "./reportWebVitals";
import { BUGSNAG_KEY } from "./utils/Constants";
import Bugsnag from "@bugsnag/js";
import BugsnagPluginReact from "@bugsnag/plugin-react";

// Only initialize Bugsnag in production, skip in development/localhost
const isLocalhost = window.location.hostname === 'localhost' || 
                    window.location.hostname === '127.0.0.1' ||
                    window.location.hostname === '';
const isDevelopment = process.env.NODE_ENV === 'development';
const shouldEnableBugsnag = !isLocalhost && !isDevelopment;

let ErrorBoundary = ({ children }) => <>{children}</>; // Default fallback ErrorBoundary

if (shouldEnableBugsnag) {
  try {
    Bugsnag.start({
      apiKey: BUGSNAG_KEY,
      plugins: [new BugsnagPluginReact()],
    });
    ErrorBoundary = Bugsnag.getPlugin("react").createErrorBoundary(React);
  } catch (error) {
    // Silently fail if Bugsnag can't initialize
    console.warn('Bugsnag initialization failed, using fallback ErrorBoundary');
  }
}

ReactDOM.render(
  <React.StrictMode>
    <ErrorBoundary>
      <Provider store={store}>
        <ThemeApp />
      </Provider>
    </ErrorBoundary>
  </React.StrictMode>,
  document.getElementById("root")
);

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://cra.link/PWA
serviceWorkerRegistration.unregister();

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
